<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="等级名称">
                <a-input v-model="queryParam.levelName" placeholder="请输入等级名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" placeholder="请选择状态" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['plus:level:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['plus:level:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['plus:level:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="pagination"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 1 ? 'green' : 'red'">
            {{ record.status === 1 ? '启用' : '禁用' }}
          </a-tag>
        </span>
        <span slot="price" slot-scope="text, record">
          ¥{{ (record.price ).toFixed(2) }}
        </span>
        <span slot="giveAmount" slot-scope="text, record">
          ¥{{ (record.giveAmount).toFixed(2) }}
        </span>
        <span slot="commissionAmount" slot-scope="text, record">
          ¥{{ (record.commissionAmount).toFixed(2) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['plus:level:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleStatus(record)" v-hasPermi="['plus:level:edit']">
            {{ record.status === 1 ? '禁用' : '启用' }}
          </a>
          <a-divider type="vertical" v-hasPermi="['plus:level:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['plus:level:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageList, deleteLevel, updateStatus } from '@/api/plus/plusLevel'
import CreateForm from './modules/CreateForm'
import TableSetting from '@/components/TableSetting'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'PlusLevel',
  components: {
    CreateForm,
    TableSetting
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      selectedRowKeys: [],
      ids: [],
      single: true,
      multiple: true,
      // 查询参数
      queryParam: {
        levelName: undefined,
        status: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`,
        onChange: this.handlePageChange,
        onShowSizeChange: this.handlePageChange
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: '等级名称',
          dataIndex: 'levelName',
          width: 120,
          ellipsis: true
        },
        {
          title: '等级排序',
          dataIndex: 'sort',
          width: 100,
          align: 'center'
        },
        {
          title: '购买价格',
          dataIndex: 'price',
          // scopedSlots: { customRender: 'price' },
          width: 120,
          align: 'right'
        },
        {
          title: '有效期(天)',
          dataIndex: 'durationDays',
          width: 100,
          align: 'center'
        },
        // {
        //   title: '赠送金额',
        //   dataIndex: 'giveAmount',
        //   scopedSlots: { customRender: 'giveAmount' },
        //   width: 120,
        //   align: 'right'
        // },
        // {
        //   title: '分销奖励',
        //   dataIndex: 'commissionAmount',
        //   scopedSlots: { customRender: 'commissionAmount' },
        //   width: 120,
        //   align: 'right'
        // },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 80,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 200,
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    parseTime,
    /** 查询列表 */
    getList() {
      this.loading = true
      pageList({
        ...this.queryParam,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(response => {
        this.list = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    /** 页码改变 */
    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getList()
    },
    /** 表格选择改变 */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.ids = selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        levelName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认',
        content: '是否确认删除编号为"' + ids + '"的数据项?',
        onOk: () => {
          return deleteLevel(ids).then(() => {
            this.getList()
            this.$message.success('删除成功')
          })
        }
      })
    },
    /** 状态修改操作 */
    handleStatus(row) {
      const status = row.status === 1 ? 0 : 1
      const statusText = status === 1 ? '启用' : '禁用'
      this.$confirm({
        title: '确认',
        content: '是否确认' + statusText + '等级"' + row.levelName + '"?',
        onOk: () => {
          return updateStatus(row.id, status).then(() => {
            this.getList()
            this.$message.success(statusText + '成功')
          })
        }
      })
    }
  }
}
</script>
